import { ROUTER_PATH } from "config/path";

export const getPdfPreviewUrl = (
  fileUrl?: string,
  title?: string,
  attachmentUrls: string[] = [],
): string | null => {
  if (!fileUrl) {
    return null;
  }

  const searchParams = new URLSearchParams({
    fileUrl,
  });

  if (title?.trim()) {
    searchParams.set("title", title);
  }

  attachmentUrls
    .filter(Boolean)
    .forEach((attachmentUrl) =>
      searchParams.append("attachmentUrl", attachmentUrl),
    );

  return `${ROUTER_PATH.preview.pdf}?${searchParams.toString()}`;
};

const openPdfPreview = (
  fileUrl?: string,
  title?: string,
  attachmentUrls: string[] = [],
): void => {
  const previewUrl = getPdfPreviewUrl(fileUrl, title, attachmentUrls);

  if (!previewUrl) {
    return;
  }

  window.open(previewUrl, "_blank");
};

export default openPdfPreview;
